import { DeletePersonTenant, DeletePersonTenantVariables } from './__generated__/DeletePersonTenant'

import { gql } from 'apollo-boost'
import { useMutation } from '@apollo/react-hooks'

const MUTATION = gql`
  mutation DeletePersonTenant($input: DeletePersonTenantAssociationInput!) {
    deletePersonTenantAssociation(input: $input) {
      id
    }
  }
`

export const useDeletePersonTenant = () => {
  return useMutation<DeletePersonTenant, DeletePersonTenantVariables>(MUTATION)
}
